enum ToastMessages {
  ERROR = "Oups ! Une erreur est survenue.",
  ERROR_RETRY = "Une erreur est survenue. Merci de réessayer ultérieurement.",
  ERROR_UPDATE = ERROR_RETRY,
  ERROR_NOT_FOUND = "Nous n'avons pas trouvé la ressource à laquelle vous essayez d'accéder.",
  ERROR_FORBIDDEN = "Vous n'avez pas les droits nécessaires pour accéder à cette ressource.",
  ERROR_INTERNAL_SERVER_ERROR = ERROR,

  ENVOI_COMMANDE_SUCESS = "Votre commande a bien été envoyée",
  CREATION_ARTICLE_SUCCESS = "Le nouvel article a bien été créé",
  CREATION_ARTICLE_ERROR = "Une erreur est survenue lors de la création de l'article",
  MODIFICATION_ARTICLE_SUCCESS = "L'article a bien été modifié",
  MODIFICATION_ARTICLE_ERROR = "Une erreur est survenue lors de la modification de l'article",
  NO_CHANGES = "Aucune modification détectée !",
  PANIER_AJOUT = "L'article a bien été ajouté au panier",
  NO_BON_DE_COMMANDE = 'Un ou plusieurs articles ont le statut "Commandé" mais aucun N° de bon de commande renseigné',
}

export default ToastMessages;
